import * as angular from 'angular';
import SharingPanelBridge from './SetupSharingPanelBridge';

angular
  .module('flowingly.components')
  .component('setupSharingPanel', SharingPanelBridge);
